(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vacdra-everyday-setup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.vacdraMiniAddBound) return;
  window.vacdraMiniAddBound = true;
  window.addEventListener('click', async (event) => {
    const button = event.target.closest('button[data-vx-add-mini]');
    if (!button || button.disabled) return;
    const form = button.closest('form');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const error = form.querySelector('.vx-growth__cart-error');
    if (error) error.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Add to cart failed');
      await response.json();
      const success = form.querySelector('.vx-growth__cart-success');
      if (success) {
        success.hidden = false;
        success.querySelector('[role="status"]')?.focus();
      }
      button.disabled = false;
      button.removeAttribute('aria-busy');
    } catch (failure) {
      if (error) error.hidden = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vd-announcement"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vd-festive-announcement'))customElements.define('vd-festive-announcement',class extends HTMLElement{
 connectedCallback(){requestAnimationFrame(()=>this.initialize());}
 initialize(){
  if(this.ready)return;this.ready=true;this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
  this.slides=[...this.querySelectorAll('[data-ann-slide]')];this.pauseButton=this.querySelector('[data-ann-pause]');
  this.querySelector('[data-ann-prev]').addEventListener('click',()=>this.show(this.index-1,true));
  this.querySelector('[data-ann-next]').addEventListener('click',()=>this.show(this.index+1,true));
  this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.syncPause();});
  this.addEventListener('mouseenter',()=>this.hovered=true);this.addEventListener('mouseleave',()=>this.hovered=false);
  this.querySelector('[data-winter-open]')?.addEventListener('click',event=>{const club=document.querySelector('vd-winter-club');if(club&&typeof club.open==='function'){event.preventDefault();club.open();}});
  if(this.classList.contains('vd-announcement--product')){
    this.querySelectorAll('[data-pop-words]').forEach(el=>{const text=el.textContent;el.setAttribute('aria-label',text);el.textContent='';text.split(/\s+/).forEach((word,i)=>{const span=document.createElement('span');span.textContent=word+' ';span.style.setProperty('--word',i);span.setAttribute('aria-hidden','true');el.appendChild(span);});});
    this.querySelectorAll('[data-type-words]').forEach(el=>{const text=el.textContent;el.setAttribute('aria-label',text);el.textContent='';Array.from(text).forEach((letter,i)=>{const span=document.createElement('span');span.textContent=letter;span.style.setProperty('--letter',i);span.setAttribute('aria-hidden','true');el.appendChild(span);});});
  }
  this.syncPause();this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!this.contains(document.activeElement)&&!document.hidden)this.show(this.index+1,false);},this.classList.contains('vd-announcement--product')?12000:6500);
 }
 show(index,manual){this.index=(index+this.slides.length)%this.slides.length;this.querySelector('[data-ann-slides]').setAttribute('aria-live',manual?'polite':'off');this.slides.forEach((slide,i)=>slide.hidden=i!==this.index);this.querySelector('[data-ann-count]').textContent=String(this.index+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');}
 syncPause(){this.dataset.paused=String(this.paused);this.pauseButton.setAttribute('aria-pressed',String(this.paused));this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel);this.querySelector('[data-ann-pause-icon]').hidden=this.paused;this.querySelector('[data-ann-play-icon]').hidden=!this.paused;}
 disconnectedCallback(){clearInterval(this.timer);this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vd-experience"] && !Shopify.designMode) return;
  try {
    
function initVd(root) {
  if (root.dataset.vdReady) return;
  root.dataset.vdReady = 'true';
  root.querySelectorAll('[data-stat-flip]').forEach(button => {
    button.addEventListener('click', () => {
      const open = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', String(open));
      button.querySelector('.vd-stat-front').setAttribute('aria-hidden', String(open));
      button.querySelector('.vd-stat-back').setAttribute('aria-hidden', String(!open));
      button.classList.remove('vd-stat-impact');
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        requestAnimationFrame(() => requestAnimationFrame(() => button.classList.add('vd-stat-impact')));
      }
    });
  });
  const tabs = [...root.querySelectorAll('[data-vd-tab]')];
  const choose = tab => {
    tabs.forEach(item => { const on = item === tab; item.setAttribute('aria-selected', String(on)); item.tabIndex = on ? 0 : -1; });
    root.querySelectorAll('[data-vd-panel]').forEach(panel => { panel.hidden = panel.dataset.vdPanel !== tab.dataset.vdTab; });
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => choose(tab));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next !== undefined) { event.preventDefault(); choose(tabs[next]); tabs[next].focus(); }
    });
  });
  const gallery = [...root.querySelectorAll('[data-vd-gallery]')];
  if (gallery.length) {
    let current = 0;
    const image = root.querySelector('.vd-hero-image');
    const changeImage = index => {
      current = (index + gallery.length) % gallery.length;
      const button = gallery[current];
      image.removeAttribute('srcset'); image.src = button.dataset.src; image.alt = button.dataset.imageAlt;
      root.querySelector('[data-vd-hero-stage]').dataset.vdGalleryState = current === 0 ? 'hand' : 'detail';
      root.querySelector('[data-vd-gallery-count]').textContent = String(current + 1).padStart(2, '0') + ' / ' + String(gallery.length).padStart(2, '0');
      gallery.forEach((item, i) => item.setAttribute('aria-pressed', String(i === current)));
    };
    gallery.forEach((button, index) => button.addEventListener('click', () => changeImage(index)));
    root.querySelector('[data-vd-gallery-prev]').addEventListener('click', () => changeImage(current - 1));
    root.querySelector('[data-vd-gallery-next]').addEventListener('click', () => changeImage(current + 1));
  }
  const wall = root.querySelector('[data-vd-video-wall]');
  if (wall) {
    const tiles = [...wall.querySelectorAll('.vd-video-tile')];
    const initialBounds = wall.getBoundingClientRect();
    let visible = initialBounds.bottom > 0 && initialBounds.top < window.innerHeight, timer;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const playback = wall.querySelector('[data-video-playback]');
    let pausedByUser = reduced.matches;
    const updatePlayback = () => {
      playback.textContent = pausedByUser || playback.dataset.blocked ? playback.dataset.play : playback.dataset.pause;
      playback.setAttribute('aria-pressed', String(pausedByUser));
    };
    updatePlayback();
    const sync = () => tiles.forEach(tile => {
      const video = tile.querySelector('video');
      video.muted = true;
      if (visible && !document.hidden && !tile.hidden && !pausedByUser && !video.dataset.userPaused) video.play().catch(() => { playback.dataset.blocked = 'true'; updatePlayback(); });
      else video.pause();
    });
    const rotate = () => {
      if (tiles.length <= 4) return;
      const shown = tiles.filter(tile => !tile.hidden);
      const waiting = tiles.filter(tile => tile.hidden);
      const outgoing = shown[Math.floor(Math.random() * shown.length)];
      const incoming = waiting[Math.floor(Math.random() * waiting.length)];
      outgoing.hidden = true;
      incoming.hidden = false;
      wall.querySelector('.vd-video-grid').insertBefore(incoming, outgoing);
      sync();
    };
    const schedule = () => {
      clearInterval(timer);
      if (visible && !document.hidden && !pausedByUser && tiles.length > 4) timer = setInterval(() => {
        if (!wall.contains(document.activeElement)) rotate();
      }, 6000);
    };
    tiles.forEach(tile => {
      const video = tile.querySelector('video');
      video.addEventListener('pointerdown', () => { video.dataset.userPaused = video.paused ? '' : 'true'; });
    });
    playback.addEventListener('click', () => {
      pausedByUser = playback.dataset.blocked ? false : !pausedByUser;
      delete playback.dataset.blocked;
      if (!pausedByUser) tiles.forEach(tile => { delete tile.querySelector('video').dataset.userPaused; });
      updatePlayback(); sync(); schedule();
    });
    wall.querySelector('[data-video-shuffle]').hidden = tiles.length <= 4;
    wall.querySelector('[data-video-shuffle]').addEventListener('click', rotate);
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); schedule(); }, {threshold: .08});
    observer.observe(wall);
    sync(); schedule();
    document.addEventListener('visibilitychange', () => { sync(); schedule(); });
    reduced.addEventListener('change', () => { pausedByUser = reduced.matches; updatePlayback(); sync(); schedule(); });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) { clearInterval(timer); observer.disconnect(); }
    });
  }
  const variant = root.querySelector('[data-vd-variant]');
  if (variant) {
    const update = () => {
      const option = variant.options[variant.selectedIndex];
      const quantity = root.querySelector('input[name="quantity"]:checked').value;
      root.querySelector('[data-vd-price]').textContent = option.dataset.one;
      root.querySelector('[data-vd-one]').textContent = option.dataset.one;
      root.querySelector('[data-vd-two]').textContent = option.dataset.two;
      root.querySelector('[data-vd-total]').textContent = quantity === '2' ? option.dataset.two : option.dataset.one;
    };
    variant.addEventListener('change', update);
    root.querySelectorAll('input[name="quantity"]').forEach(input => input.addEventListener('change', update));
  }
}
document.querySelectorAll('[data-vd-root]').forEach(initVd);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-vd-root]').forEach(initVd));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vd-footer"]) return;
  try {
    
if(!customElements.get('vd-winter-club'))customElements.define('vd-winter-club',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('[data-club-open]');this.trigger.addEventListener('click',()=>this.open());this.querySelectorAll('[data-club-close]').forEach(button=>button.addEventListener('click',()=>this.dialog.close()));this.dialog.addEventListener('click',event=>{if(event.target===this.dialog){const box=this.dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)this.dialog.close();}});this.dialog.addEventListener('close',()=>{this.remember();if(this.lastFocus)this.lastFocus.focus();});const toggle=this.querySelector('[data-season-toggle]');toggle.addEventListener('click',()=>{const paused=document.body.classList.toggle('vd-season-paused');toggle.setAttribute('aria-pressed',String(paused));toggle.textContent='❄ '+(paused?toggle.dataset.play:toggle.dataset.pause);});if(this.querySelector('[data-club-success]')||this.querySelector('.errors')){this.open();}else{let last=0;try{last=Number(localStorage.getItem('vd-winter-club-seen')||0);}catch{}if(Date.now()-last>604800000)this.timer=setTimeout(()=>{if(!document.hidden&&!document.querySelector('dialog[open]')&&!document.querySelector('#shopify-pc__banner'))this.open();},30000);}}
open(){if(this.dialog.open)return;this.lastFocus=document.activeElement;this.dialog.showModal();this.remember();}
remember(){try{localStorage.setItem('vd-winter-club-seen',String(Date.now()));}catch{}}
disconnectedCallback(){clearTimeout(this.timer);this.ready=false;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vd-product-popups"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vd-product-popups'))customElements.define('vd-product-popups',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.openHandler=event=>{const trigger=event.target.closest('[data-vd-open]');if(!trigger)return;event.preventDefault();this.open(trigger.dataset.vdOpen,trigger);};document.addEventListener('click',this.openHandler);
  this.querySelectorAll('dialog').forEach(dialog=>{
   dialog.querySelector('[data-vd-close]').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
   dialog.addEventListener('close',()=>{dialog.querySelectorAll('video').forEach(video=>video.pause());if(!this.querySelector('dialog[open]')){document.documentElement.classList.remove('vd-modal-open');this.trigger?.focus();}});
  });
  const tabs=[...this.querySelectorAll('[data-popup-tab]')];tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>this.panel(tab.dataset.popupTab));tab.addEventListener('keydown',event=>{let next;if(event.key==='ArrowRight')next=(index+1)%tabs.length;if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;if(next!==undefined){event.preventDefault();this.panel(tabs[next].dataset.popupTab);tabs[next].focus();}});});
  const select=this.querySelector('[data-popup-variant]'),quantity=this.querySelector('[data-popup-quantity]');const update=()=>{const option=select.options[select.selectedIndex];this.querySelector('[data-popup-price]').textContent=option.dataset.one;this.querySelector('[data-popup-total]').textContent=quantity.value==='2'?option.dataset.two:option.dataset.one;};select.addEventListener('change',update);quantity.addEventListener('change',update);
 }
 panel(mode){this.querySelectorAll('[data-popup-tab]').forEach(tab=>{const active=tab.dataset.popupTab===mode;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;});this.querySelectorAll('[data-popup-panel]').forEach(panel=>{panel.hidden=panel.dataset.popupPanel!==mode;if(panel.hidden)panel.querySelectorAll('video').forEach(video=>video.pause());});}
 open(mode,trigger){if(typeof HTMLDialogElement==='undefined')return;this.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close());this.trigger=trigger;const dialog=this.querySelector('[data-vd-dialog="'+(mode==='quick'?'quick':'learn')+'"]');if(mode!=='quick')this.panel(['demo','specs','box'].includes(mode)?mode:'demo');dialog.showModal();dialog.scrollTop=0;document.documentElement.classList.add('vd-modal-open');}
 disconnectedCallback(){document.removeEventListener('click',this.openHandler);this.querySelectorAll('dialog[open]').forEach(dialog=>dialog.close());this.ready=false;}
});

  } catch(e) { console.error(e); }
})();
})();
